export const getImageDimensions = (src: string): Promise<{ w: number; h: number }> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve({ w: img.width, h: img.height });
        img.onerror = reject;
        img.src = src;
    });
};

/**
 * Resolves an image URL to be environment-agnostic.
 * - If the URL is relative (starts with /uploads), it remains relative.
 * - If the URL contains localhost or 127.0.0.1, it strips the domain and protocol to make it relative.
 * - If it's a full external URL (e.g. Unsplash), it returns it as is.
 */
export const resolveImageUrl = (url: string | null | undefined): string => {
    if (!url) return '';

    // If it's already a relative path, return as is
    if (url.startsWith('/')) return url;

    // Handle legacy/hardcoded localhost or 127.0.0.1 URLs
    if (url.includes('localhost') || url.includes('127.0.0.1')) {
        try {
            const parsed = new URL(url);
            // If it's a localhost upload, just return the path part (e.g. /uploads/...)
            if (parsed.pathname.startsWith('/uploads')) {
                return parsed.pathname;
            }
        } catch (e) {
            // Fallback for malformed URLs
            return url.replace(/^https?:\/\/[^/]+/, '');
        }
    }

    return url;
};
